import React, { useEffect, useState } from "react";
import "./breaking-news.css";

const BreakingNews = () => {
    const [breakingNews, setBreakingNews] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    const BASE = process.env.REACT_APP_API_URL || "https://news-portal-l6pf.onrender.com";
    const API_URL = `${BASE}/api/news`;

    useEffect(() => {
        fetchBreakingNews();
    }, []);

    const fetchBreakingNews = async () => {
        try {
            const res = await fetch(`${API_URL}?limit=20`);
            const result = await res.json();
            const data = result?.data || [];
            // Get most recent news as breaking news
            const recent = data.slice(0, 5);
            setBreakingNews(recent);
        } catch (err) {
            console.error("Fetch breaking news error:", err);
        }
    };

    useEffect(() => {
        if (breakingNews.length === 0) return;

        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % breakingNews.length);
        }, 6000); // Change every 6 seconds

        return () => clearInterval(interval);
    }, [breakingNews.length]);

    if (breakingNews.length === 0) {
        return null;
    }

    const current = breakingNews[currentIndex];

    return (
        <div className="breaking-news-container">
            <div className="breaking-news-badge">
                <span className="pulse"></span>
                <span className="breaking-text">🔴 BREAKING NEWS</span>
            </div>

            <div className="breaking-news-content">
                <div className="news-ticker">
                    <div className="ticker-item active">
                        <h6 className="m-0">{current?.title || ""}</h6>
                    </div>
                </div>

                <div className="ticker-indicator">
                    {breakingNews.map((_, idx) => (
                        <span
                            key={idx}
                            className={`indicator ${idx === currentIndex ? "active" : ""}`}
                        ></span>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BreakingNews;
